/* ============================================================
   LX MOTION SYSTEM â€” Luxury Streetwear
   Built for: Shrine 1.3.0 (Dawn-based)
   Cleaned for: FARAONE1447 drawer/menu stability
   ============================================================ */

(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isDesktop = window.matchMedia('(min-width: 750px)').matches;
  var inEditor = window.Shopify && window.Shopify.designMode;
  var lenis = null;

  function getHeaderGroup() {
    return document.querySelector('.shopify-section-group-header-group');
  }

  function syncHeaderState() {
    var group = getHeaderGroup();
    if (!group) return;

    if (document.body.classList.contains('lx-home')) {
      if (window.scrollY > 120) group.classList.add('lx-scrolled');
      else group.classList.remove('lx-scrolled');
    }
  }

  window.lxSyncHeaderState = syncHeaderState;

  /* ---------- 1. LENIS SMOOTH SCROLL ---------- */
  function initLenis() {
    if (reduceMotion || inEditor || typeof Lenis === 'undefined') return;

    lenis = new Lenis({
      lerp: 0.1,
      wheelMultiplier: 0.9,
      smoothWheel: true
    });

    window.lenis = lenis;

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);
  }

  function pauseLenis() {
    if (window.lenis && typeof window.lenis.stop === 'function') {
      window.lenis.stop();
    }
  }

  function startLenis() {
    if (window.lenis && typeof window.lenis.start === 'function') {
      window.lenis.start();
    }
  }

  function unlockPageScroll() {
    document.documentElement.classList.remove(
      'overflow-hidden',
      'overflow-hidden-mobile',
      'overflow-hidden-tablet',
      'lock-scroll',
      'no-scroll',
      'drawer-open'
    );

    document.body.classList.remove(
      'overflow-hidden',
      'overflow-hidden-mobile',
      'overflow-hidden-tablet',
      'lock-scroll',
      'no-scroll',
      'drawer-open'
    );

    document.documentElement.style.overflow = '';
    document.documentElement.style.position = '';
    document.documentElement.style.top = '';

    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.top = '';

    startLenis();
    syncHeaderState();
  }

  /* ---------- 2. INTERSECTION OBSERVER REVEALS ---------- */
  function initReveals(root) {
    var scope = root || document;
    var els = scope.querySelectorAll('.lx-reveal:not(.is-in)');
    if (!els.length) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) {
        el.classList.add('is-in');
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.15,
      rootMargin: '0px 0px -10% 0px'
    });

    els.forEach(function (el) {
      observer.observe(el);
    });
  }

  /* ---------- 3. GSAP PARALLAX ---------- */
  function initParallax() {
    if (reduceMotion || !isDesktop || inEditor) return;
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

    gsap.registerPlugin(ScrollTrigger);

    if (lenis) {
      lenis.on('scroll', ScrollTrigger.update);
      gsap.ticker.lagSmoothing(0);
    }

    gsap.utils.toArray('[data-lx-parallax]').forEach(function (el) {
      var img = el.querySelector('img');
      if (!img) return;

      gsap.fromTo(img, { yPercent: -12 }, {
        yPercent: 12,
        ease: 'none',
        scrollTrigger: {
          trigger: el,
          start: 'top bottom',
          end: 'bottom top',
          scrub: true
        }
      });
    });
  }

  /* ---------- 4. HEADER SCROLL FLIP ---------- */
  function initHeaderFlip() {
    syncHeaderState();
    window.addEventListener('scroll', syncHeaderState, { passive: true });
    window.addEventListener('resize', syncHeaderState);
    window.addEventListener('pageshow', syncHeaderState);
  }

  /* ---------- 5. MOBILE MENU ACCORDION ---------- */
  function closeMobileMenu() {
    var container = document.querySelector('#Details-menu-drawer-container');
    if (container) {
      container.removeAttribute('open');
      container.classList.remove('menu-opening');
    }

    var summary = document.querySelector('#Details-menu-drawer-container > summary');
    if (summary) {
      summary.setAttribute('aria-expanded', 'false');
    }

    document
      .querySelectorAll('.menu-drawer details[open]')
      .forEach(function (details) {
        details.removeAttribute('open');
      });

    document
      .querySelectorAll('.menu-drawer .submenu-open, .menu-drawer__navigation.submenu-open')
      .forEach(function (el) {
        el.classList.remove('submenu-open');
      });

    setTimeout(unlockPageScroll, 80);
  }

  function initMobileMenuControls() {
    document.addEventListener('click', function (event) {
      var closeButton = event.target.closest('.menu-drawer__close-btn');

      if (closeButton) {
        event.preventDefault();
        event.stopPropagation();
        closeMobileMenu();
        return;
      }

      var isMobile = window.matchMedia('(max-width: 989px)').matches;
      if (!isMobile) return;

      var summary = event.target.closest('.menu-drawer details > summary');
      if (!summary) return;

      var details = summary.parentElement;
      var submenu = details.querySelector('.menu-drawer__submenu');
      if (!submenu) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      var wasOpen = details.hasAttribute('open');

      document
        .querySelectorAll('.menu-drawer details[open]')
        .forEach(function (openDetails) {
          if (openDetails !== details) openDetails.removeAttribute('open');
        });

      if (wasOpen) details.removeAttribute('open');
      else details.setAttribute('open', '');

      var nav = summary.closest('.menu-drawer__navigation');
      if (nav) nav.classList.remove('submenu-open');
    }, true);
  }

  /* ---------- 6. CART DRAWER STABILITY ---------- */
  function afterDrawerClose() {
    setTimeout(function () {
      unlockPageScroll();
      syncHeaderState();
    }, 120);
  }

  function initDrawerControls() {
    document.addEventListener('click', function (event) {
      var cartOpener = event.target.closest('[id^="cart-icon-bubble"], #cart-icon-bubble, a[href="/cart"]');
      var cartClose = event.target.closest('cart-drawer .drawer__close, .cart-drawer .drawer__close, #CartDrawer-Overlay');
      var menuOpener = event.target.closest('#Details-menu-drawer-container > summary');

      if (cartOpener) {
        setTimeout(pauseLenis, 80);
      }

      if (menuOpener) {
        setTimeout(pauseLenis, 80);
      }

      if (cartClose) {
        afterDrawerClose();
      }
    }, true);

    document.addEventListener('keyup', function (event) {
      if (event.key === 'Escape') {
        afterDrawerClose();
      }
    });

    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && 'MutationObserver' in window) {
      var observer = new MutationObserver(function () {
        var isOpen =
          cartDrawer.classList.contains('active') ||
          cartDrawer.classList.contains('animate') ||
          document.body.classList.contains('overflow-hidden');

        if (!isOpen) {
          afterDrawerClose();
        }
      });

      observer.observe(cartDrawer, {
        attributes: true,
        attributeFilter: ['class']
      });
    }
  }

  /* ---------- INIT ---------- */
  function boot() {
    initLenis();
    initReveals();
    initParallax();
    initHeaderFlip();
    initMobileMenuControls();
    initDrawerControls();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  if (inEditor) {
    document.addEventListener('shopify:section:load', function (event) {
      initReveals(event.target);
      syncHeaderState();
    });
  }
})();

/* ============================================================
   FARAONE1447 — MOBILE MENU OUTSIDE CLICK SCROLL UNLOCK
   Fixes: clicking outside menu closes it but leaves page unscrollable
   ============================================================ */

(function () {
  function unlockScrollAfterMenuClose() {
    setTimeout(function () {
      document.documentElement.classList.remove(
        "overflow-hidden",
        "lock-scroll",
        "no-scroll",
        "drawer-open"
      );

      document.body.classList.remove(
        "overflow-hidden",
        "lock-scroll",
        "no-scroll",
        "drawer-open"
      );

      document.documentElement.style.overflow = "";
      document.documentElement.style.position = "";
      document.documentElement.style.top = "";
      document.documentElement.style.touchAction = "";

      document.body.style.overflow = "";
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.touchAction = "";

      if (window.lenis && typeof window.lenis.start === "function") {
        window.lenis.start();
      }
    }, 120);
  }

  function watchMobileMenuDetails() {
    var menuDetails = document.getElementById("Details-menu-drawer-container");
    if (!menuDetails) return;

    var observer = new MutationObserver(function () {
      if (!menuDetails.hasAttribute("open")) {
        unlockScrollAfterMenuClose();
      }
    });

    observer.observe(menuDetails, {
      attributes: true,
      attributeFilter: ["open", "class"]
    });
  }

  document.addEventListener("DOMContentLoaded", watchMobileMenuDetails);

  if (document.readyState !== "loading") {
    watchMobileMenuDetails();
  }

  document.addEventListener(
    "click",
    function (event) {
      var menuDetails = document.getElementById("Details-menu-drawer-container");
      if (!menuDetails || !menuDetails.hasAttribute("open")) return;

      var clickedInsideMenu = event.target.closest("#menu-drawer");
      var clickedMenuButton = event.target.closest("#Details-menu-drawer-container > summary");
      var clickedCloseButton = event.target.closest(".menu-drawer__close-btn");

      if (!clickedInsideMenu && !clickedMenuButton && !clickedCloseButton) {
        unlockScrollAfterMenuClose();
      }
    },
    true
  );
})();